import(/* webpackMode: "eager" */ "D:\\Github-Agents\\GHA-1\\_work\\FBO\\FBO\\Procom.Phoenix.Web\\Phoenix\\microapps\\workflow-hub-v2\\app\\page.tsx");
